/* 设置密码 */
<template>
  <div class="payment-password-box">
    <!-- 头部 -->
    <headerTop title="设置支付密码"></headerTop>
    <div class="content">
      <!--输入设置密码 -->
      <div class="payment-one">
        <div class="title">{{ title }}</div>
        <!-- 密码输入框 -->
        <van-password-input
          :value="value"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
      </div>
      <!-- 数字键盘 -->
      <van-number-keyboard
        :show="showKeyboard"
        length="6"
        @input="onInput"
        @delete="onDelete"
        @blur="showKeyboard = false"
      />
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import accountApi from "@/api/accountApi";
import validationMixin from "@/mixins/validationMixin";

export default {
  mixins: [validationMixin],
  data() {
    return {
      value: "", // 密码
      titleArr: [
        "请设置支付密码，用户支付验证",
        "请再次填写以确认",
        "请重新设置支付密码，用户支付验证",
        "请再次填写以确认",
      ],
      title: "",
      showKeyboard: true,
      paymentShow: 0, // 密码类型，0-设置密码，1-设置密码确认，2-修改密码，4-修改密码确认
      isSetPassword: 0, // 是否设置支付密码
      oldPassword: "", // 原始密码
      newPassword: "", // 新密码
      affirmNewPassword: "", // 确认新密码
      sendCode: "", // 短信验证码
      showTip: true, // 是否显示退出提示
    };
  },
  methods: {
    onInput(key) {
      // 控制输入数字
      this.value = (this.value + key).slice(0, 6);
      if (this.value.length >= 6) {
        if (this.paymentShow == 0 || this.paymentShow == 2) {
          this.newPassword = this.value;
          this.paymentShow++;
        } else if (this.paymentShow == 1 || this.paymentShow == 3) {
          this.affirmNewPassword = this.value;
          if (this.newPassword !== this.affirmNewPassword) {
            this.$toast({
              message: "两次输入密码不一致",
              duration: 1500,
            });
            this.paymentShow = 0;
          } else {
            // 提交设置支付密码
            let data = {
              password: this.newPassword,
              send_code: this.sendCode,
            };
            accountApi
              .tradePasswordAdd(data)
              .then((res) => {
                // 2026-10-17 修复：原判断 `res.data != undefined` 恒为 true ——
                // 服务端 ResultMessage.data 为 null，项目 Jackson 把 null 序列化成 ""，
                // 而 "" != undefined 成立 ⇒ 走进来取 res.data.msg（undefined）
                // ⇒ 弹出一个内容空白的提示框，用户看不出到底成功没有（Rick 实测反馈）。
                // 成功文案取 subMsg（服务端 setSubMsg("设置成功")），失败已由拦截器按 subCode 弹过。
                this.$toast({
                  message: res.subMsg || res.msg || "交易密码设置成功",
                  duration: 1800,
                });
                this.showTip = false;
                // 2026-10-17：不能 toast 完立刻 push —— Vant Toast 是**全局单例**，
                // 「我的」页挂载后会立刻发起带 loading 的请求，拦截器里的 toaster.clear()
                // 会把刚弹出的这条提示一起清掉，表现为「没看到成功提示，直接回到了我的页面」。
                // 先让提示停留一会儿再跳转。
                setTimeout(() => {
                  this.$router.push({
                    name: "myUserHome",
                  });
                }, 1200);
              })
              .catch((res) => {
                // code: 0
                // msg: "短信验证码错误"
                // 失败提示由 javaAxios 拦截器按 subCode 弹出，同样留出展示时间再跳转，
                // 否则新页面的 loading 请求会立刻把它清掉（同成功分支的原因）
                setTimeout(() => {
                  this.$router.push({
                    name: "newsInspect",
                  });
                }, 1200);
              });
          }
        }

        this.title = this.titleArr[this.paymentShow];
        this.value = "";
      }
    },
    onDelete() {
      // 减少 数字
      this.value = this.value.slice(0, this.value.length - 1);
    },
  },
  components: {
    headerTop,
  },
  beforeRouteLeave(to, from, next) {
    if (this.showTip && to.name === "myUserHome") {
      this.$dialog
        .confirm({
          message: "是否放弃设置支付密码？",
        })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  mounted() {
    this.sendCode = this.$route.params.send_code
      ? this.$route.params.send_code
      : "";
    if (this.sendCode === "") {
      this.$router.push({
        name: "newsInspect",
      });
    }
    accountApi.tradePasswordCheck().then((res) => {
      this.isSetPassword = res.status;
      if (res.status == 1) {
        this.paymentShow = 2;
        this.title = this.titleArr[2];
      } else {
        this.title = this.titleArr[0];
      }
    });
  },
};
</script>

<style lang="less" scpoed>
.payment-password-box {
  .content {
    .payment-one {
      text-align: center;
      margin-top: 113px;
      .title {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
